<template>
	<div class="w5-error-page">
		<template v-if="!$store.state.is_auth">
			<img :src="stylePathToLogo || '/static/img/logo/logo.png'" />
			<br><br><br>
		</template>
		<div class="page-404">4<div class="bird-map"></div>4</div>
		<div class="alert alert-danger" role="alert">
			<p>К сожалению, запрашиваемая страница не найдена.</p>
			<router-link v-if="$store.state.is_auth" to="/">Вы можете вернуться на главную страницу.</router-link>
		</div>
		
	</div>
</template>

<script>
export default {
	name: 'notFoundPage'
}
</script>

<style scoped>
.w5-error-page {
	position: fixed;
	top: 20%;
	left: 25%;	
	text-align: center;
	width: 50%;	
}

.page-404 {
	text-align: center;
	font-size: 101px;
	font-weight: 500;
	color: black;
}

.page-404 .bird-map {
	margin: 0 10px;
	display: inline-block;
	height: 74px;
	width: 74px;	
	background: url(/static/img/bird-map.svg);
	background-size: cover;
}

@media (max-width: 767px) {
	.w5-error-page {
		left: 10%;
		width: 80%;
	}
}
</style>



// WEBPACK FOOTER //
// notFound.vue?91e6715c